import { blue, blueGrey, grey } from '@mui/material/colors';
import dayjs from 'dayjs';
export const TIMEZONE = 'America/Caracas';

export const dateformat = (
  date = dayjs(),
  {
    format = 'YYYY-MM-DD',
    full = false,
    isHHmm = false,
    isHHmmss = false,
    complete = false,
    dateOnly = false,
    inverse = false,
    standard = false,
    timezone = 'America/Caracas',
  },
) => {
  if (timezone) {
    var _timezone = require('dayjs/plugin/timezone');
    dayjs.extend(_timezone);
    dayjs.tz.setDefault(timezone);
  }

  if (dateOnly) {
    return dayjs(complete ? `2000-01-01 ${date}` : date) ?? dayjs();
  }

  return dayjs((complete ? `2000-01-01 ${date}` : date) ?? dayjs()).format(
    standard
      ? 'DD/MM/YYYY'
      : inverse
      ? 'DD-MM-YYYY'
      : full
      ? 'YYYY-MM-DD HH:mm:ss'
      : isHHmmss
      ? 'HH:mm:ss'
      : isHHmm
      ? 'HH:mm'
      : format,
  );
};

export const getSumaTimeHelper = (time, suma) => {
  const date = dateformat(null, {});
  return dayjs(`${date} ${time}`).add(suma, 'minute');
};

export const textLabels = {
  body: {
    noMatch: 'No se encontrarón registros',
    toolTip: 'Ordenar',
    columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
  },
  pagination: {
    next: 'Pág, Siguiente',
    previous: 'Pág, Anterior',
    rowsPerPage: 'Filas por página:',
    displayRows: 'de',
  },
  toolbar: {
    search: 'Buscar',
    downloadCsv: 'Download CSV',
    print: 'Print',
    viewColumns: 'View Columns',
    filterTable: 'Filter Table',
  },
  filter: {
    all: 'TODOS',
    title: 'FILTROS',
    reset: 'REINICIAR',
  },
  viewColumns: {
    title: 'Show Columns',
    titleAria: 'Show/Hide Table Columns',
  },
  selectedRows: {
    text: 'row(s) selected',
    delete: 'Delete',
    deleteAria: 'Delete Selected Rows',
  },
};

export const diasDeSemanaUtil = [
  {
    id: 0,
    dia: 'DOMINGO',
    en: 'Sunday',
    abrev: 'Dom',
    resourceId: 0,
    resourceTitle: 'DOMINGO',
    color: blueGrey[400],
  },
  {
    id: 1,
    dia: 'LUNES',
    en: 'Monday',
    abrev: 'Lun',
    resourceId: 1,
    resourceTitle: 'LUNES',
    color: blue[50],
  },
  {
    id: 2,
    dia: 'MARTES',
    en: 'Tuesday',
    abrev: 'Mar',
    resourceId: 2,
    resourceTitle: 'MARTES',
    color: blue[100],
  },
  {
    id: 3,
    dia: 'MIERCOLES',
    en: 'Wednesday',
    abrev: 'Mié',
    resourceId: 3,
    resourceTitle: 'MIERCOLES',
    color: blue[200],
  },
  {
    id: 4,
    dia: 'JUEVES',
    en: 'Thursday',
    abrev: 'Jue',
    resourceId: 4,
    resourceTitle: 'JUEVES',
    color: blue[300],
  },
  {
    id: 5,
    dia: 'VIERNES',
    en: 'Friday',
    abrev: 'Vie',
    resourceId: 5,
    resourceTitle: 'VIERNES',
    color: blue[400],
  },
  {
    id: 6,
    dia: 'SABADO',
    en: 'Saturday',
    abrev: 'Sáb',
    resourceId: 6,
    resourceTitle: 'SABADO',
    color: blueGrey[200],
  },
];

export const stringToColor = (string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const stringAvatar = (name) => {
  return {
    sx: {
      bgcolor: grey[800],
      fontSize: '11pt',
      width: 30,
      height: 30,
    },
    children: `${name.split(' ')[0][0].toUpperCase()}${name
      .split(' ')[1][0]
      .toUpperCase()} `,
  };
};

export const generateRandomNumber = () => {
  const min = 100000000000000;
  const max = 999999999999999;
  const random = Math.floor(Math.random() * (max - min + 1)) + min;
  return random;
};

export const ExpRegSoloPhone = '^[0-9+]+$';
export const ExpRegSoloNumeros = '^[0-9]+$';
export const ExpRegSoloNumerosPassport = '^[0-9a-zA-Z]+$';
export const ExpRegSoloLetras = '^[a-z A-ZñÑáéíóúÁÉÍÓÚ]+$';
export const validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;

export const soloPhone = (value) => {
  let data = value;
  if (data) {
    data = data.replace(/[^0-9+]/g, '');
    if (data.match(ExpRegSoloPhone) == null) {
      data = data.slice(0, -1);
    }
  }
  return data;
};

export const soloNumero = (value) => {
  let data = value;
  if (data) {
    data = data.replace(/[^0-9]/g, '');
    if (data.match(ExpRegSoloNumeros) == null) {
      data = data.slice(0, -1);
    }
  }
  return data;
};

export const formatHoraHorarioHelper = (hora) => {
  const date = dateformat(null, {});
  const x = dateformat(`${date} ${hora}`, { format: 'h:mm' });
  return x;
};

export const tryCatchHelper = ({ e, notify }) => {
  let message =
    e?.response?.data?.message ||
    e?.message ||
    'Error al intentar, realizar el proceso';

  if (Array.isArray(message)) {
    message = message.join(', ');
  }

  if (notify) {
    notify(message, { error: true });
  } else {
    console.log(message);
  }
};

export function randomDate() {
  const startDate = dayjs(new Date(1970, 0, 1));
  const daysBetween = dayjs().add(-8, 'year').diff(startDate, 'day');
  const randomDay = Math.floor(Math.random() * daysBetween);
  return startDate.add(randomDay, 'day').toDate();
}

export function toPorcentajeHelper(a, b, c) {
  const result = (a * b) / c;
  return result.toFixed(2);
}

export function notaToPonderacionHelper(a, b, c) {
  return (a * b) / c;
}

export const validatePhone = (phone) => {
  const phoneRegex =
    /^(\+?\d{1,4}[-\s]?)?(\()?(\d{1,3}(\)))?[-\s]?\d{1,4}[-\s]?\d{1,9}$/;
  return phoneRegex.test(phone);
};

export function ponderacionToPiso(
  value,
  { round = false, decimal = 2, truncate = false } = {},
) {
  const factor = Math.pow(10, decimal);
  const res = round ? Math.round(value) : Math.floor(value * factor) / factor;

  console.log(res);
  console.log('truncado 2 decimales', res.toFixed(2));
  return truncate ? res.toFixed(2) : res;
}

export const formatDNI = (dni) => {
  return dni.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const getNivelText = (type) => {
  switch (type) {
    case 'EDUCACION INICIAL':
      return 'Nivel';
    case 'EDUCACION BASICA':
      return 'Grado';
    default:
      return 'Año';
  }
};
